/* eslint-disable max-len */
import { Component, Input, OnInit, ElementRef, Inject } from '@angular/core';
import { ModalController, ToastController } from '@ionic/angular';
import { AngularFirestore } from '@angular/fire/firestore';
import { format, parseISO, getDate, getMonth, getYear } from 'date-fns';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { GroupService } from 'src/app/services/group.service';

@Component({
  selector: 'app-accept-reject-member',
  templateUrl: './accept-reject-member.component.html',
  styleUrls: ['./accept-reject-member.component.scss'],
})
export class AcceptRejectMemberComponent implements OnInit {

  currentUser = this.authService.currentUser;
  unsub1;
  requests;
  constructor(
    public firestore: AngularFirestore,
    public modalCtrl: ModalController,
    public groupService: GroupService,
    public authService: AuthService,
    public formBuilder: FormBuilder,
    public toastController: ToastController,
  ) {

  }

  ngOnInit() { }

  async ionViewDidEnter() {
    console.log('ionViewDidEnter AcceptRejectMemberComponent', this.groupService.group);
    this.unsub1 = this.authService.currentAccount.subscribe(async (currentUser) => { this.currentUser = currentUser; });
    this.gatherRequests();
    window.addEventListener('group-update', () => {
      this.gatherRequests();
    });
  }

  async gatherRequests() {
    this.requests = [];
    this.groupService.group.joinRequests.forEach(async (id) => {
      this.requests.push(await this.authService.getUserById(id));
    });
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

  async presentToast(header, message) {
    const toast = await this.toastController.create({
      header,
      message,
      position: 'middle',
      cssClass: 'spcl-toast',
      duration: 2000
    });
    await toast.present();

    const { role } = await toast.onDidDismiss();
    console.log('onDidDismiss resolved with role', role);
  }

  ionViewDidLeave() {
    this.unsub1.unsubscribe();
    window.removeEventListener('group-update', () => { });
  }

}
